import { GoogleMap, InfoWindow,  withGoogleMap, withScriptjs } from "react-google-maps"
import * as React from 'react';
import { compose, withProps } from "recompose";
import Marker from 'react-google-maps/lib/components/Marker';
import { Dot } from './routeSelector';
import { DriverHistory } from '../api/model';
// import InfoBox from 'react-google-maps/lib/components/addons/InfoBox';
// import { formatDistance } from 'date-fns';
// import Button from '@material-ui/core/Button';
// import { Link } from "react-router-dom";
import LocalIcon from '../assets/imgs/cheese.png';
import { ConfigData } from "../config";


// const getColor = (data: DriverHistory): string => {
//     if (data.raceId) {
//         switch (data.raceState) {
//             case RaceState.IN_PROGRESS:
//                 return 'yellow';
//             case RaceState.DELIVERED:
//                 return 'green';
//             case RaceState.ASSIGNED:
//                 return 'red'
//         }
//     }

//     return 'purple';
// };

// interface MarkerOfDriverWithInfoProps {
//     data: DriverHistory[];
// }

// const MarkerOfDriverWithInfo: React.SFC<any> = (props: any) => {
//     const pathCoordinates = props.data.map((driverHistory: DriverHistory) => {
//         return { lat: driverHistory.lat, lng: driverHistory.lng };
//     });
//     return <Polyline
//         path={pathCoordinates}
//         options={{
//             strokeColor: "#ff2527",
//             strokeOpacity: 0.75,
//             strokeWeight: 2,
//             icons: [
//                 {
//                     offset: "0",
//                     repeat: "20px"
//                 }
//             ]
//         }}
//     />
// };

interface MapProps {

    zoom: number;
    center: Dot;
    data: DriverHistory[];
    predefinedFrom: boolean;

    handleOnClick(e: google.maps.MouseEvent | google.maps.IconMouseEvent): void;

}

class MapOfDrivers extends React.Component<MapProps, { open: { [K: number]: boolean }, selectedMarker: DriverHistory | null }> {

    constructor(props: MapProps) {
        super(props);
        this.state = {
            open: {},
            selectedMarker: null
        }
    }

    toggle = (info: DriverHistory) => {
        this.setState({
            open: {
                [info.id]: !this.state.open[info.id]
            }
        })
    };

    handleMarkerClick = (driverHistory: DriverHistory) => {
        this.setState({ selectedMarker: driverHistory });
    };

    handleInfoWindowCloseClick = () => {
        this.setState({ selectedMarker: null });
    };


    render() {

        const { center, zoom, handleOnClick } = this.props;
        return <div>
            <GoogleMap defaultZoom={zoom} center={center} onClick={handleOnClick}>
                {this.props.predefinedFrom && <Marker
                    position={this.props.center}
                    labelContent="Meet & Cheese"
                    icon={{
                        url: LocalIcon,
                        scale: 3
                    }}
                />}
                {/* <MarkerOfDriverWithInfo data={this.props.data} /> */}

                {this.props.data.map((driverHistory: DriverHistory, index: number) => (
                    <Marker
                    label={{ text: `${index + 1}`, color: "white", fontSize: "14px" }}
                        key={index}
                        position={{ lat: driverHistory.lat, lng: driverHistory.lng }}
                        onClick={() => {
                            this.handleMarkerClick(driverHistory);
                        }}
                    />
                ))}

                {this.state.selectedMarker && (
                    <InfoWindow
                        position={{ lat: this.state.selectedMarker.lat, lng: this.state.selectedMarker.lng }}
                        onCloseClick={this.handleInfoWindowCloseClick}
                    >
                        <div style={{ backgroundColor: 'black', padding: 12, width: 300 }}>
                            <div style={{ color: `white` }}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Fecha:</td>
                                            <td>{this.state.selectedMarker.locationDateTime}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </InfoWindow>
                )}
            </GoogleMap>
        </div>
    }
}

const EnhancedMap = compose<MapProps, MapProps>(
    withProps({
        containerElement: <div style={{ height: '400px' }} />,
        mapElement: <div style={{ height: '400px' }} />,
    }),
    withGoogleMap
)(MapOfDrivers);

interface DriverHistoryLocationProps {
    data: DriverHistory[],
    config: ConfigData;
}

const DriverHistoryLocationComponent: React.SFC<DriverHistoryLocationProps> = (props: DriverHistoryLocationProps) => {

    return (
        <EnhancedMap
            center={props.config.maps.startingLocation}
            predefinedFrom={props.config.races.predefinedFrom}
            zoom={props.config.maps.startingLocation.zoom}
            data={props.data}
            handleOnClick={(dat) => {
                console.log(dat)
            }}
        >
        </EnhancedMap>
    );

};


export default compose<any, DriverHistoryLocationProps>(withProps((props: DriverHistoryLocationProps) => {
    return {
        googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${props.config.maps.key}`,
        loadingElement: <div style={{ height: '400px' }} />,
    }
}), withScriptjs)(DriverHistoryLocationComponent);



// WEBPACK FOOTER //
// ./src/components/DriverHistoryLocation.tsx